<template>
	<ul class='block-main-list' :class='{ hearings: showButtonsForHearing }'>
    <li v-if='showButtonsForMeeting' class='block-main-list-item'>
      <a :href='urlAgenda' class='icon icon-calendar icon-left'>{{textAgenda}}</a>
    </li>
    <li v-if='showButtonsForMeeting' class='block-main-list-item'>
      <a :href='urlSpeakerList' class='icon icon-speech icon-left'>{{textSpeakerList}}</a>
    </li>
    <li v-if='showButtonsForHearing' class='block-main-list-item'>
      <a :href='urlHearingAgenda' class='icon icon-calendar icon-left'>{{textHearingAgenda}}</a>
    </li>
    <li class='block-main-list-item'>
      <a :href='urlVideoArchive' class='icon icon-video icon-left'>{{textVideoArchive}}</a>
    </li>
  </ul>
</template>

<script>
import mixins from '../../mixins'
import lang from '../../lang'

export default {
  mixins: [mixins],
  name: 'top-text-box-bottom-buttons',
  data () {
    return {
      urlAgenda: undefined,
      textAgenda: lang.agenda[this.$root.cmsData.lang],
      urlSpeakerList: this.$root.cmsData.mainBlock.speakerListUrl,
      textSpeakerList: lang.speakerList[this.$root.cmsData.lang],
      urlHearingAgenda: undefined,
      textHearingAgenda: lang.hearingAgenda[this.$root.cmsData.lang],
      urlVideoArchive: this.$root.cmsData.mainBlock.tvArchiveUrl,
      textVideoArchive: lang.videoArchive[this.$root.cmsData.lang]
    }
  },
  computed: {
    showButtonsForMeeting: function () {
      return this.liveHelper().shouldShowMeetingButtons(this.$root.cmsData, this.$root.liveData)
    },
    showButtonsForHearing: function () {
      return this.liveHelper().shouldShowHearingButtons(this.$root.cmsData, this.$root.liveData)
    }
  },
  created () {
    if (this.showButtonsForMeeting) {
      this.urlAgenda = this.liveHelper().agendaUrl(this.$root.liveData)
    } else if (this.showButtonsForHearing) {
      this.urlHearingAgenda = this.liveHelper().hearingProgramUrl(this.$root.cmsData, this.$root.liveData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopTextBoxBottomButtons.vue?38572b21